import type { SyntheticEvent } from 'react';

const ROW_CLICK_DISABLED_ATTRIBUTE = 'data-row-click-disabled';

const blockedRowClickEvents = new WeakSet<Event>();

const stopEvent = (event: SyntheticEvent) => event.stopPropagation();

const markRowClickBlocked = (event: SyntheticEvent) => {
  blockedRowClickEvents.add(event.nativeEvent);
};

export const rowClickBlockerProps = {
  [ROW_CLICK_DISABLED_ATTRIBUTE]: true,
  onClickCapture: markRowClickBlocked,
  onClick: stopEvent,
  onMouseDown: stopEvent,
  onPointerDown: stopEvent,
} as const;

export const isRowClickDisabledTarget = (event: Event | null | undefined) =>
  event !== null &&
  event !== undefined &&
  (blockedRowClickEvents.has(event) ||
    (event.target instanceof Element &&
      event.target.closest(`[${ROW_CLICK_DISABLED_ATTRIBUTE}]`) !== null));
